import { EventEmitter } from '@angular/core';
import { AttributionMode } from 'SecuritiesApp/ts/features/attribution-factor-analysis/attribution-bar-chart-enums';
import { PerformancePeriodicity } from 'SecuritiesApp/ts/interfaces/attribution.interface';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../../charts/static/charts/ts/features/factor-coefficient-range/factor-coefficient-range-chart.component";
import * as i2 from "../../../../../../../../../ycharts/static/ts/features/components/modals/help-modal/components/help-modal.component";
const _forTrack0 = ($index, $item) => $item.value;
const _forTrack1 = ($index, $item) => $item.factorLabel;
function AttributionFactorProfileComponent_For_10_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "a", 22);
    i0.ɵɵlistener("click", function AttributionFactorProfileComponent_For_10_Template_a_click_1_listener() { const periodicityOption_r4 = i0.ɵɵrestoreView(_r3).$implicit; const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.updatePeriodicityHandler.emit(periodicityOption_r4.value)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const periodicityOption_r4 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(i0.ɵɵinterpolate1("chart-control-item ", periodicityOption_r4.value === ctx_r4.performancePeriodicity ? "current" : ""));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", periodicityOption_r4.label, " ");
} }
function AttributionFactorProfileComponent_Conditional_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17)(1, "div", 23);
    i0.ɵɵtext(2, "Category Average ");
    i0.ɵɵelementEnd()();
} }
function AttributionFactorProfileComponent_For_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21)(1, "div", 24)(2, "div", 25)(3, "div", 26)(4, "div", 27);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(6, "ycn-factor-coefficient-range", 28);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const f_r6 = ctx.$implicit;
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(f_r6.factorLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("rangeData", f_r6);
} }
export class AttributionFactorProfileComponent {
    constructor() {
        this.factorCoefficientRangeData = [];
        this.updatePeriodicityHandler = new EventEmitter();
    }
}
AttributionFactorProfileComponent.ɵfac = function AttributionFactorProfileComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AttributionFactorProfileComponent)(); };
AttributionFactorProfileComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AttributionFactorProfileComponent, selectors: [["ycn-attribution-factor-profile"]], inputs: { factorCoefficientRangeData: "factorCoefficientRangeData", securityType: "securityType", selectedAttribution: "selectedAttribution", periodicityOptions: "periodicityOptions", performancePeriodicity: "performancePeriodicity" }, outputs: { updatePeriodicityHandler: "updatePeriodicityHandler" }, standalone: false, decls: 31, vars: 1, consts: [["helpModal", ""], [1, "panel", "panel-data"], [1, "panel-header"], [1, "panel-title"], [1, "help-toggler", 3, "click"], [1, "panel-actions"], [1, "panel-action"], [1, "chart-control", "chart-control-compact", "border-0"], [3, "class"], [1, "panel-content"], [1, "chart-cover"], [1, "chart-interactive"], [1, "chart-item"], [1, "chart-options", "border-b", "border-color-gray-90"], [1, "row"], [1, "col"], [1, "chart-legend"], [1, "chart-legend-item"], [1, "chart-legend-item-title", "bullet-gradient-3c"], [1, "chart-legend-item-title", "bullet-blue-ada"], [1, "chart-options"], [1, "align-items-center", "border-b", "border-color-gray-90", 2, "width", "100%", "margin-top", "6px"], ["href", "javascript:void(0)", 1, "chart-control-link", 3, "click"], [1, "chart-legend-item-title", "custom-bullet-line"], [1, "flex-auto"], [1, "d-flex", "align-items-center"], [1, "width-90", 2, "margin-right", "5px"], [1, "text-bold"], [2, "width", "100%", 3, "rangeData"]], template: function AttributionFactorProfileComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "h3", 3);
        i0.ɵɵtext(3, " Factor Profile\u00A0 ");
        i0.ɵɵelementStart(4, "span", 4);
        i0.ɵɵlistener("click", function AttributionFactorProfileComponent_Template_span_click_4_listener() { i0.ɵɵrestoreView(_r1); const helpModal_r2 = i0.ɵɵreference(30); return i0.ɵɵresetView(helpModal_r2.openModal("attribution_factor_profile")); });
        i0.ɵɵtext(5, " (?) ");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(6, "div", 5)(7, "div", 6)(8, "ul", 7);
        i0.ɵɵrepeaterCreate(9, AttributionFactorProfileComponent_For_10_Template, 3, 4, "li", 8, _forTrack0);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(11, "div", 9)(12, "div", 10)(13, "div", 11)(14, "div", 12)(15, "div", 13)(16, "div", 14)(17, "div", 15)(18, "div", 16)(19, "div", 17)(20, "div", 18);
        i0.ɵɵtext(21, "Historical Range");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(22, "div", 17)(23, "div", 19);
        i0.ɵɵtext(24, "Primary Security");
        i0.ɵɵelementEnd()();
        i0.ɵɵconditionalCreate(25, AttributionFactorProfileComponent_Conditional_25_Template, 3, 0, "div", 17);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(26, "div", 20);
        i0.ɵɵrepeaterCreate(27, AttributionFactorProfileComponent_For_28_Template, 7, 2, "div", 21, _forTrack1);
        i0.ɵɵelementEnd()()()()();
        i0.ɵɵelement(29, "ycn-help-modal", null, 0);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(9);
        i0.ɵɵrepeater(ctx.periodicityOptions);
        i0.ɵɵadvance(16);
        i0.ɵɵconditional(ctx.securityType !== "model_portfolio" ? 25 : -1);
        i0.ɵɵadvance(2);
        i0.ɵɵrepeater(ctx.factorCoefficientRangeData);
    } }, dependencies: [i1.FactorCoefficientRangeChart, i2.HelpModalComponent], encapsulation: 2 });
